<!-- skeletons -->
<ng-container *ifLoaded="(sportsLayout$ | async) || (message$ | async); template: 'two-column'"></ng-container>
<div data-test="sports-list" class="min-vh-100 sm-container-w-100 sports-list-page">
  <ng-container *ngIf="!(isLayoutError$ | async); else error">
    <ng-container *ngIf="(sportsLayout$ | async) as sport">
      <flo-content-right-rail-layout
        [container]="sport.content"
        [topContent]="sport.topContent"
        [secondaryContainer]="sport.rightRailContent"
        [bottomContent]="sport.bottomContent"
        [message]="message$ | async"
      ></flo-content-right-rail-layout>
    </ng-container>
  </ng-container>
  <ng-template #error>
    <div class="container bg-white min-vh-100 py-5" data-test="sports-error">
      <flo-error></flo-error>
    </div>
  </ng-template>
</div>
